import React    from 'react';
import { withRouter } from 'react-router';
import CustomLink from 'components/Link/Link.react';


const LinkToBack = (props) => {

  const { params, location, router, routes, ...rest } = props;


  if(location.state && location.state.backURL) {
    const stateWithoutBack = {
      ...location.state,
      backURL: null,
    };

    return (
      <CustomLink {...rest} to={location.state.backURL} />
    );
  }

  return (
    <CustomLink {...rest} to={props.defaultback || '/'} />
  );
};

export default withRouter(LinkToBack);